import { useDataLayerAction } from '../TagContext'
import { useEffect } from 'react'
import { Maybe, Products } from '@pylot-data/fwrdschema'

export const useSearchTracking = (
    searchTerm?: string | string[],
    visibleProductData?: Maybe<Products>,
    isValidating?: boolean
): void => {
    const dataLayerAction = useDataLayerAction()
    useEffect(() => {
        if (searchTerm && visibleProductData && !isValidating) {
            dataLayerAction({
                type: 'SEARCH',
                data: {
                    searchTerm,
                    ...visibleProductData
                }
            })
        }
    }, [dataLayerAction, visibleProductData])
}
